import React, { useState } from 'react';
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert
} from 'reactstrap';
import { connect } from 'react-redux';
import { publishParentQuery } from '../../api/parentQuery';

const ConfirmModal = ({
  isOpen,
  handleClose,
  queryData,
  setSuccessAlert,
  handleRefresh
}) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitError, setSubmitError] = useState({ show: false, message: '' });
  const handlePublish = async () => {
    try {
      setSubmitLoading(true);
      await publishParentQuery(queryData._id);
      setSuccessAlert({
        show: true,
        message: 'Answered published successfully'
      });
      handleClose();
      handleRefresh();
    } catch (error) {
      console.error('Failed to publish answer: ', error);
      setSubmitError({
        show: true,
        message:
          error?.response?.data?.error ||
          error?.message ||
          'Failed to publish answer'
      });
    } finally {
      setSubmitLoading(false);
    }
  };
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} backdrop="static" size="lg">
        <ModalHeader toggle={handleClose}>Publish Answer</ModalHeader>
        <ModalBody>
          {submitError.show && (
            <Alert
              color="danger"
              role="alert"
              isOpen={submitError.show}
              toggle={() => setSubmitError({ show: false, message: '' })}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {submitError.message}
            </Alert>
          )}
          <Row>
            <Col md="12">
              <h5>Are you sure you want to publish this answer ?</h5>
              <p className="mt-1 mb-0">
                <b>Q: </b>
                {queryData?.query}
              </p>
              <p>
                <b>A: </b>
                {queryData?.answer}
              </p>
            </Col>

            <Col>
              <ModalFooter>
                <Button
                  disabled={submitLoading}
                  type="button"
                  color="light"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  color="success"
                  disabled={submitLoading}
                  onClick={handlePublish}
                >
                  {submitLoading ? 'Publishing...' : 'Publish'}
                </Button>
              </ModalFooter>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(ConfirmModal);
